var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-input',{directives:[{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],class:_vm.inputClass,attrs:{"type":"text","disabled":_vm.disabled,"readonly":_vm.readonly,"required":_vm.required,"placeholder":_vm.placeholder,"maxlength":_vm.maxlength},nativeOn:{"change":function($event){return _vm.alteracao($event)},"blur":function($event){return _vm.consequencia($event)}},model:{value:(_vm.valor),callback:function ($$v) {_vm.valor=$$v},expression:"valor"}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/shared-components/InputMoneyOld.vue?vue&type=template&id=5940dc7e&
// module id = 1016
// module chunks = 28